<template>
  <main
    class="bg-gradient py-5"
    style="background:url(https://drfone.wondershare.com/images2019/home-banner-bg.jpg) no-repeat center top; background-size:cover;"
  >
    <div class="container container-xl">
      <div class="row justify-content-between py-lg-5 pl-lg-5">
        <div class="col-12 col-md-7 col-lg-6  text-center text-white">
          <div class="container py-5 text-white">
            <h1 class="h3 font-weight-normal">Transmore</h1>
            <h2 class="h1">Share Large Files Securely, Easily, and Quickly</h2>
            <div class="d-flex mt-4 align-items-center justify-content-center">
              <div class="mr-3"><a href="https://play.google.com/store/apps/details?id=com.wondershare.transmore&amp;hl=en"><img src="https://drfone.wondershare.com/images2019/btn-google-play.png" height="62" alt="google play"></a></div>
            </div>
            <div class="d-flex mt-4 align-items-center justify-content-center">
              <div class="mr-3"><a href="https://itunes.apple.com/us/app/transmore/id1455968861?ls=1&amp;mt=8"><img src="https://drfone.wondershare.com/images2019/btn-app-store.png" width="204" alt="app store"></a></div>
            </div>
            <!--<div class="mt-4"><a href="https://drfone.wondershare.com/transmore.html" class="text-white font-size-large">Or try dr.fone - Transfer Online</a></div>-->
          </div>
          <!--<h2 class="h1">dr.fone Cloud</h2>-->
          <!--<h4 class="py-3">Transmore</h4>-->
          <!--<p class="font-size-huge">Share Large Files Securely, Easily, and Quickly.</p>-->
        </div>
        <div class="col-12 col-md-5 col-lg-5">
          <my-transfer></my-transfer>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import MyTransfer from "../components/transfer/MyTransfer";
import request from "../utils/Request";
export default {
  name: "Transfer",
  components: { MyTransfer },
  created() {
    request({
      url: "/v1/transfer/configs"
    }).then(response => {
      if (response.code === 200) {
        this.$store.commit("set_configs", response.data);
      }
    });
  },
  mounted() {
    // if (!this.$store.state.user.username) {
    //   $("#login-box").addClass("show");
    // }
  }
};
</script>

<style scoped></style>
